// auth.js
export const LOGOUT = 'LOGOUT';
export const SAVE_TOKEN = 'SAVE_TOKEN';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';
export const UPDATE_USER = 'UPDATE_USER';
export const ADD_COUNTRIES = 'COUNTRIES';
export const ADD_COUNTRY = 'COUNTRY';
export const ADD_REGIONS = 'ADD_REGIONS';
export const ADD_REGION = 'ADD_REGION';
export const ADD_CITIES = 'ADD_CITIES';
export const ADD_CITY = 'ADD_CITY';
export const ADD_GYMS = 'ADD_GYMS';
export const ADD_GYM = 'ADD_GYM';
export const UPDATE_GYM = 'UPDATE_GYM';
export const DELETE_GYM = 'DELETE_GYM';
export const CHECKING_GYM_NAME = 'CHECKING_GYM_NAME';
export const ADD_GYM_BY_ID = 'ADD_GYM_BY_ID';
export const ADD_SUBSCRIPTIONS = 'ADD_SUBSCRIPTIONS';
export const ADD_SUBSCRIPTION = 'ADD_SUBSCRIPTION';
export const UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION';
export const ADD_SUBSCRIPTION_BY_ID = 'ADD_SUBSCRIPTION_BY_ID';



// WEBPACK FOOTER //
// ./resources/assets/js/store/mutation-types.js